import {
    Branch, Customer, TaxArea, Address, CustomerContact, WebTrackPaymentResult, WebTrackPaymentToken
} from 'ep-bt-field-agent-proxy';
import { QuickOrderLineModel } from './quick-order-line.model';
import { EpbtFaShoppingCartModel } from './epbt-fa-shopping-cart-model';
import { EpbtFaReturnParametersModel } from './epbt-fa-return-parameters-model';
import { EpbtFaEpaReturnParametersModel } from './epbt-fa-epa-return-parameters-model';

export class QuickOrderModel {
    constructor() {

    }

    public customer: Customer;
    public branch: Branch;
    public selectedSalesType: number;
    public deliveryAddress: Address;
    // public get customer(): Customer {
    //     return this.customer;
    // }
    // public set customer(value: Customer) {
    //     this.customer = value;
    // }

    // public get branch(): Branch {
    //     return this.branch;
    // }
    // public set branch(value: Branch) {
    //     this.branch = value;
    //     // this.SetDefaultTaxArea();
    // }

    // public get selectedSalesType(): number {
    //     return this.selectedSalesType;
    // }
    // public set selectedSalesType(value: number) {
    //     this.selectedSalesType = value;
    //     // this.SetDefaultTaxArea();
    // }

    // public get deliveryAddress(): Address {
    //     return this.deliveryAddress;
    // }
    // public set deliveryAddress(value: Address) {
    //     this.deliveryAddress = value;
    //     // this.SetDefaultTaxArea();
    // }

    public TransactionType = 1;

    public nextLineNumber = 1;

    public dateRequired: Date;
    public customerRef: string;
    public contact: CustomerContact;
    public taxArea: TaxArea;
    public specialInstructions: any;
    public Lines: QuickOrderLineModel[] = [];
    public PaymentAmount: number;
    // Following 2 properties needs to be populated when user if attaching files to Quick Order

    public OrderID = 0;
    public OrderNumber = 0;

    PaymentToken: WebTrackPaymentToken;
    public PaymentResult: WebTrackPaymentResult;
    public AttemptedQuickOrderPayment: boolean;
    public currentCart: EpbtFaShoppingCartModel;
    public i4GoReturnParameters: EpbtFaReturnParametersModel;
    public epaReturnParameters: EpbtFaEpaReturnParametersModel;
    public i4GoError: string;

    /// <summary>
    /// Add QuickOrderLine and specify whether this line should be deleted
    /// when the user clicks Cancel, w/o saving it first.
    /// </summary>
    /// <param name="line"></param>
    /// <param name="adding"></param>
    LineAdd(line: QuickOrderLineModel, adding: boolean = true) {
        line.SetLineNumber(this.nextLineNumber++);
        line.Adding = adding;
        this.Lines.push(line);
    }

    LineRemove(lineNumber: number) {
        const orderLine = this.Lines.filter(x => x.LineNumber == lineNumber)[0];
        this.Lines.splice(this.Lines.indexOf(orderLine), 1);
    }

    private _TotalSellPrice: number;
    public get TotalSellPrice(): number {
        // return this._TotalSellPrice;
        // this.Lines.Sum(l => l.TotalSellPrice);
        return this.Lines.reduce((sum, item) => sum + item.TotalSellPrice, 0);
    }

    private _TotalTax: number;
    public get TotalTax(): number {
        // var tax = this.Lines.reduce((sum, item) => sum + item.TotalTax, 0)
        // return tax ? tax : 0;
        return this.Lines.reduce((sum, item) => sum + item.TotalTax, 0);
    }

    private _TotalAmount: number;
    public get TotalAmount(): number {
        // return this._TotalAmount;
        // this.Lines.Sum(l => l.TotalAmount);
        return this.TotalSellPrice + this.TotalTax;
    }
}
